module.exports = __webpack_public_path__ + "img/YE.3eff7be3.svg";